<template>
  <modal :name="modalName" :width="780" :height="'auto'" :scrollable="true" :adaptive="true">
    <div class="tpl">
      <div class="tpl-header">
        <div class="tpl-header__left">
          <div class="tpl-header__icon"><fa-icon icon="layer-group" /></div>
          <div>
            <div class="tpl-header__eyebrow">Galeria de templates</div>
            <h3 class="tpl-header__title">Comece a partir de um modelo</h3>
          </div>
        </div>
        <button type="button" class="tpl-close" @click="close"><fa-icon icon="times" /></button>
      </div>

      <div class="tpl-grid">
        <div v-for="t in templates" :key="t.slug" class="tpl-card" @click="aplicar(t)">
          <div class="tpl-card__icon"><fa-icon :icon="t.icon || 'bolt'" /></div>
          <div class="tpl-card__body">
            <div class="tpl-card__title">{{ t.nome }}</div>
            <div class="tpl-card__desc">{{ t.descricao }}</div>
            <div class="tpl-card__meta">
              <span class="tpl-card__badge"><fa-icon icon="bolt" /> {{ t.evento }}</span>
              <span class="tpl-card__badge"><fa-icon icon="play-circle" /> {{ t.acoes.length }} ação(ões)</span>
            </div>
          </div>
        </div>
      </div>

      <div class="tpl-footer">
        <button type="button" class="tpl-btn tpl-btn--ghost" @click="close">Cancelar</button>
      </div>
    </div>
  </modal>
</template>

<script>
const TEMPLATES = [
  {
    slug: 'pedido-alto-valor',
    nome: 'Notificar gerente em pedido > 10k',
    descricao: 'Quando um pedido for faturado com valor acima de R$ 10.000, criar aviso interno para o gestor.',
    evento: 'PedidoFaturado',
    icon: 'dollar-sign',
    condition_type: 'visual',
    condition_visual: { grupos: [{ logica: 'AND', condicoes: [{ campo: 'pedido.valortotal', operador: 'maior', valor: '10000' }] }] },
    field_labels: { 'pedido.valortotal': 'Valor total do pedido' },
    acoes: [{ acao_tipo_slug: 'notification', acao_config: {}, on_error: 'continue' }],
  },
  {
    slug: 'cancelamento-webhook',
    nome: 'Notificar webhook em cancelamento',
    descricao: 'Em todo pedido cancelado, dispara um webhook externo com o payload do evento.',
    evento: 'PedidoCancelado',
    icon: 'plug',
    condition_type: 'visual',
    condition_visual: { grupos: [] },
    acoes: [{ acao_tipo_slug: 'call_webhook', acao_config: {}, on_error: 'abort' }],
  },
  {
    slug: 'orcamento-email',
    nome: 'Confirmação por e-mail ao virar pedido',
    descricao: 'Quando um orçamento for convertido em pedido, envia e-mail de confirmação ao cliente.',
    evento: 'OrcamentoEnviadoPedido',
    icon: 'envelope',
    condition_type: 'visual',
    condition_visual: { grupos: [] },
    acoes: [{ acao_tipo_slug: 'send_email', acao_config: {}, on_error: 'continue' }],
  },
  {
    slug: 'liberacao-ticket',
    nome: 'Abrir ticket SAC ao liberar pedido',
    descricao: 'Cria um ticket interno toda vez que um pedido é liberado para faturamento.',
    evento: 'PedidoLiberado',
    icon: 'ticket-alt',
    condition_type: 'visual',
    condition_visual: { grupos: [] },
    acoes: [{ acao_tipo_slug: 'create_ticket', acao_config: {}, on_error: 'continue' }],
  },
];

export default {
  name: 'AcaoObjetoTemplatesModal',
  props: { modalName: { type: String, default: 'acaoObjetoTemplates' } },
  data() { return { templates: TEMPLATES }; },
  methods: {
    aplicar(t) {
      const form = {
        nome: t.nome,
        descricao: t.descricao,
        evento: t.evento,
        ativo: false,
        ordem: 0,
        validar_todas_regras: true,
        condition_type: t.condition_type,
        condition_visual: JSON.parse(JSON.stringify(t.condition_visual || { grupos: [] })),
        condition_sql: t.condition_sql || '',
        regras: [],
        acoes: JSON.parse(JSON.stringify(t.acoes || [])),
        __field_labels: JSON.parse(JSON.stringify(t.field_labels || {})),
      };
      this.$emit('apply', form);
      this.close();
    },
    close() { this.$modal.hide(this.modalName); },
  },
};
</script>

<style scoped>
.tpl { background: #fff; }
.tpl-header { display: flex; align-items: center; justify-content: space-between; padding: 18px 22px; background: linear-gradient(135deg, #f9fafb 0%, #f2f2f8 100%); border-bottom: 1px solid #e4e7eb; }
.tpl-header__left { display: flex; align-items: center; gap: 14px; }
.tpl-header__icon { width: 42px; height: 42px; border-radius: 10px; background: linear-gradient(135deg, #3a3e81, #5b60a6); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 16px; }
.tpl-header__eyebrow { font-size: 11px; font-weight: 600; color: #3a3e81; text-transform: uppercase; letter-spacing: 0.5px; }
.tpl-header__title { margin: 2px 0 0; font-size: 18px; font-weight: 700; color: #1d2939; }
.tpl-close { width: 34px; height: 34px; border-radius: 8px; border: 1px solid #e4e7eb; background: #fff; color: #667085; cursor: pointer; }
.tpl-close:hover { background: #d9534f; color: #fff; border-color: #d9534f; }

.tpl-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; padding: 20px 22px; }
@media (max-width: 768px) { .tpl-grid { grid-template-columns: 1fr; } }

.tpl-card {
  display: flex;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s ease;
  background: #fff;
}
.tpl-card:hover { border-color: #3a3e81; box-shadow: 0 4px 12px rgba(58, 62, 129, 0.12); transform: translateY(-2px); }
.tpl-card__icon { width: 38px; height: 38px; border-radius: 8px; background: #f2f2f8; color: #3a3e81; display: flex; align-items: center; justify-content: center; font-size: 14px; flex-shrink: 0; }
.tpl-card__title { font-size: 13px; font-weight: 700; color: #1d2939; }
.tpl-card__desc { font-size: 12px; color: #667085; line-height: 1.4; margin: 4px 0 8px; }
.tpl-card__meta { display: flex; gap: 6px; flex-wrap: wrap; }
.tpl-card__badge { font-size: 10px; font-weight: 600; color: #475467; background: #f2f4f7; border-radius: 4px; padding: 2px 7px; display: inline-flex; align-items: center; gap: 4px; }

.tpl-footer { padding: 14px 22px; border-top: 1px solid #e4e7eb; display: flex; justify-content: flex-end; }
.tpl-btn { padding: 9px 18px; border-radius: 8px; font-size: 13px; font-weight: 600; cursor: pointer; border: 1px solid #dddce9; background: #fff; color: #475467; }
</style>
